import axios from 'axios'
import { ALOHOMORA } from "gatsby-env-variables"

export const makeRequestAlohomora = async (data) => {
	const response = await axios.post(ALOHOMORA, data)
	return response
}
